'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.directive('tlOnExcelPaste', function () {
  var plainToTable = function plainToTable(text) {
    var table = [];
    var rowSeparator = '\n';
    if (text.indexOf('\r\n') > -1) {
      rowSeparator = '\r\n';
    }
    _.each(text.trim(rowSeparator).split(rowSeparator), function (rowData, lineIdx) {
      table[lineIdx] = [];
      _.each(rowData.split('\t'), function (cellData, rowIdx) {
        table[lineIdx][rowIdx] = cellData;
      });
    });
    return table;
  };
  return {
    restrict: "A",
    priority: 100,
    link: function link($scope, $el, $attrs) {
      var pasteHandler = $scope.$eval($attrs.tlOnExcelPaste);
      $el.bind('paste', function (e) {
        if (e.originalEvent == null || e.originalEvent.clipboardData == null || e.originalEvent.clipboardData.items.length === 0) {
          return;
        }
        e.preventDefault();
        e.stopImmediatePropagation();
        var items = e.originalEvent.clipboardData.items;
        for (var i = 0; i < items.length; i++) {
          var item = items[i];
          if (item.kind === 'string' && item.type === 'text/plain') {
            item.getAsString(function (s) {
              var parsed = plainToTable(s);
              $scope.$apply(function () {
                pasteHandler(parsed);
              });
            });
          }
        }
      });
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/tl/tlOnExcelPaste.js
// module id = 2907
// module chunks = 13